export default {
  LIST: "list",
  PANEL: "panel",
};
